import { useQuery } from '@tanstack/react-query';

import { apiFetch } from './api-client';
import { API_BASE } from './api-base';
import type { PulseRun } from '../pages/api/pulse-run-history';

export const pulseRunsKey = (routineId: string | undefined) => ['pulse-runs', routineId] as const;

/** A routine's newest recorded runs (`routine-run-history`). */
export async function fetchPulseRuns(routineId: string): Promise<PulseRun[]> {
  const res = await apiFetch(`${API_BASE}/api/pulse-run-history`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ routineId }),
  });
  if (!res.ok) throw new Error(`pulse-run-history ${res.status}`);
  const data: { runs?: PulseRun[] } = await res.json();
  return data.runs ?? [];
}

export function usePulseRuns(routineId: string | undefined) {
  return useQuery({
    queryKey: pulseRunsKey(routineId),
    enabled: !!routineId,
    queryFn: () => fetchPulseRuns(routineId as string),
  });
}
